import { useTranslation } from "react-i18next";
import { ParamsType } from "interfaces";
import { Swiper, SwiperSlide } from "swiper/react";
import { useQuery } from "react-query";
import productService from "services/product";
import ProductCard from "components/productCard/productCard";
import { Skeleton } from "@mui/material";
import cls from "./productList.module.scss";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";

type Props = {
  title: string;
  params?: ParamsType;
  enabled?: boolean;
};

export default function ProductList({
  title,
  params = {},
  enabled = true,
}: Props) {
  const { t, i18n } = useTranslation();

  const { data, isFetching } = useQuery({
    queryKey: ["products", i18n.language, params],
    queryFn: () => {
      const paramsData = {
        lang: i18n.language,
        perPage: 10,
        page: 1,
        ...params,
      };
      return productService.getAll(paramsData);
    },
    enabled,
  });

  // ⬇️ MINIMA MODIFICA
  const filtered = data?.data?.filter((p) => p.id !== params.product_id);

  if (!isFetching && !filtered?.length) {
    return <span />;
  }

  const renderView = () => {
    if (isFetching) {
      return Array.from(new Array(4)).map((_, index) => (
        <SwiperSlide key={index}>
          <Skeleton variant="rectangular" key={index} className={cls.shimmer} />
        </SwiperSlide>
      ));
    }
    return filtered?.map((product) => (
      <SwiperSlide key={product?.id}>
        <ProductCard data={product} />
      </SwiperSlide>
    ));
  };

  return (
    <section className={cls.container}>
      <div className={cls.header}>
        <span className={cls.title}>{t(title)}</span>
      </div>
      <Swiper
        navigation
        modules={[Navigation]}
        spaceBetween={20}
        breakpoints={{
          1500: {
            slidesPerView: 6,
          },
          1200: {
            slidesPerView: 5,
          },
          1000: {
            slidesPerView: 4,
          },
          700: {
            slidesPerView: 3,
          },
          450: {
            slidesPerView: 2,
          },
          0: {
            slidesPerView: 1,
          },
        }}
      >
        {renderView()}
      </Swiper>
    </section>
  );
}
